import { render, staticRenderFns } from "./XCodeEditor.vue?vue&type=template&id=35ac0c08&"
import script from "./XCodeEditor.vue?vue&type=script&lang=js&"
export * from "./XCodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./XCodeEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports